import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import AppSentinelsMappingForm from './AppSentinelsMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { urlRegexValidator } from 'utils/formUtils';

function AppSentinelsCredentialForm(props, ref) {
    const fields = useMemo(() => [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator]
        },
        {
            name: "apikey",
            label: "API Key",
            required: true,
            type: FieldTypes.PASSWORD,
        },
        {
            name: "x-user-key",
            label: "User Key",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ], []);

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={AppSentinelsMappingForm}
        />
    )
}

export default forwardRef(AppSentinelsCredentialForm);